var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout_page"},[_c('div',{staticClass:"logout_message"},[_c('h2',[_vm._v("已登出，将跳转首页......")])])])
}]

export { render, staticRenderFns }